<script>
import SectionTitle from '@components/section-title'
import con from '@services/connection'
import Vue from 'vue'
import rules from '@constants/Rules'
import {
  cadastroClientes,
  servicos,
  tarefasDia,
  sendLink,
} from '@constants/URL'
import store from '@state/store'
import { possivelJSON } from '@utils/Format'
import { MODAL, RELOAD, CANT_ACCESS_FUNCTION } from '@constants/Text'
import { GlobalBus } from '@services/bus'
import { copyToClipboard } from '@utils/Clipboard'
import SelectEmail from '@components/select-email-to'
import { apiClientsComunication } from '@api/clients/apiClientsComunication'

const MENSAGEM_LOTE_SUCESSO = 'Links enviados com sucesso'
const MENSAGEM_ERRO_SEM_DETALHE =
  'Não foi possível enviar os links. Tente novamente mais tarde ou contate o suporte.'
const MENSAGEM_PARCIAL_SEM_DETALHE =
  'Parte dos clientes não recebeu o link. Confira os cadastros sem e-mail e reenvie.'

/**
 * Lê uma lista de dentro do `value` da resposta sem confiar no formato.
 * O envio em lote passou a devolver `value = { enviados, sem_email, falhas }`
 * (PR AAWZ/aawz_base#1315), mas rotas antigas — e backend não atualizado —
 * ainda devolvem `value` como null, número ou lista. Sem optional chaining:
 * o Babel deste projeto não transpila `?.`.
 */
const listaDoValue = (value, chave) => {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return []
  }
  const lista = value[chave]
  return Array.isArray(lista) ? lista : []
}

/**
 * Sucesso PARCIAL: o backend enviou para alguém (status 200) mas deixou
 * clientes de fora. É o caso que o front exibia como sucesso total.
 */
const envioParcial = (res) => {
  if (!res || res.status !== 200) {
    return false
  }
  const value = res.value
  return (
    listaDoValue(value, 'sem_email').length > 0 ||
    listaDoValue(value, 'falhas').length > 0
  )
}

export default {
  components: {
    SectionTitle,
    SelectEmail,
  },
  props: {
    bus: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      rules: rules,
      args: null,
      dialog: false,
      busModal: new Vue(),
      step: 1,
      key: 0,
      loadingNovo: false,
      service: '',
      servicos: [],
      clients: [],
      searchClient: '',
      emailFrom: '',
      selectedsClients: [],
      showClients: true,
      headersClients: [
        {
          text: 'Nome',
          align: 'left',
          value: 'nome_cliente',
        },
        {
          text: 'Email',
          value: 'email',
        },
        {
          text: '',
          value: 'action',
          sortable: false,
        },
      ],
      selectedsServices: [],
      headersServices: [
        {
          text: 'Serviço',
          align: 'left',
          value: 'nome_servico',
        },
        {
          text: 'Taxa',
          value: 'taxa',
          width: 130,
        },
        {
          text: 'Descricao',
          value: 'descricao_servico',
        },
        {
          text: '',
          value: 'action',
          sortable: false,
        },
      ],
      shareLink: 'by_link',
      linkAdesao: '',
      assunto_email: '',
      texto_email: '',
      enviar_imagem: false,
      enviar_copia: false,
      enviar_anexo: false,
      email_cco: '',
      email_cc: '',
      receber_copia: false,
      enviar_assinatura_email: false,
      close: false,
      loadingClients: false,
      loadingServices: false,
      id_prospect: '',
    }
  },
  computed: {
    textSubtitle() {
      if (this.service && this.service.nome_servico) {
        return `Serviço: ${this.service.nome_servico}`
      }
      if (this.selectedsClients.length > 0 && !this.showClients) {
      }
      return `${this.selectedsClients.length} clientes selecionados`
    },
    escritorio() {
      return store.getters['user/currentUser'].escritorio
    },
  },
  created() {
    if (this.bus) {
      this.bus.$on(MODAL.SEND_LINK, this.open)
    }
    GlobalBus.$on(MODAL.SEND_LINK, this.open)
    GlobalBus.$on(RELOAD.CLIENTS, this.getClients)
    GlobalBus.$on(RELOAD.SERVICES, this.getServices)
  },
  beforeDestroy() {
    if (this.bus) {
      this.bus.$off(MODAL.SEND_LINK, this.open)
    }
    GlobalBus.$off(MODAL.SEND_LINK, this.open)
    GlobalBus.$off(RELOAD.CLIENTS, this.getClients)
    GlobalBus.$off(RELOAD.SERVICES, this.getServices)
  },
  methods: {
    open(v, clients, args) {
      if (!this.$canSendLinks) {
        this.$showSnack({
          text: CANT_ACCESS_FUNCTION,
          button: true,
        })
        return
      }
      this.clearData()
      if (v) {
        this.service = v
        this.selectedsServices.push(v)
      }
      if (clients && clients.length > 0) {
        this.selectedsClients = clients // lista c obj inteiro. {id}*
        this.showClients = false
      } else {
        this.showClients = true
      }
      this.args = args
      this.key += 1
      this.getData()
      if (clients && clients.length === 1) {
        this.id_prospect = clients[0].id
      }

      this.assunto_email = `Bem-vindo(a) ao aplicativo da ${this.escritorio
        .nome || 'Escritório'}!`
      this.texto_email =
        'Temos uma plataforma especial para cuidar dos seus investimentos. No link abaixo você pode conferir nossos serviços e realizar cadastro'

      this.busModal.$emit('dialog', true)
    },
    getData() {
      this.getServices()
      this.getClients()
    },
    getClients() {
      if (!this.showClients || this.loadingClients) {
        return
      }
      this.loadingClients = true
      con.get(sendLink.listar_clientes).then((res) => {
        if (res && res.status === 200) {
          this.clients = possivelJSON(res.value)
        }
        this.loadingClients = false
      })
    },
    changeStep() {
      this.step = Number(this.step) + 1
    },
    openNewClient() {
      this.bus.$emit(MODAL.CADASTRAR_CLIENTES, true)
    },
    openNewService() {
      this.bus.$emit(MODAL.CADASTRAR_SERVICOS, true)
    },
    async nextStepNovo(close) {
      if (this.step === this.calcStep(4)) {
        close()
        return
      }
      if (this.step === this.calcStep(1)) {
        if (!this.selectedsClients.length) {
          this.$showSnack({
            text: 'Selecione pelo menos um cliente',
            button: true,
          })
          return
        }
        if (this.service || this.selectedsServices.length) {
          await this.generateLinkAdesao()
        }
      }
      if (this.step === this.calcStep(2)) {
        // Permitir enviar comunicado (sem serviço)
        // if (!this.selectedsServices.length) {
        //   this.$showSnack({
        //     text: 'Selecione pelo menos um serviço',
        //     button: true,
        //   })
        //   return
        // }
        this.shareLink = this.selectedsServices.length ? 'by_link' : 'by_email'
        await this.generateLinkAdesao()
      }
      if (this.step === this.calcStep(1) && this.service) {
        this.selectedService()
        return
      }
      this.step = Number(this.step) + 1
    },
    async generateLinkAdesao() {
      if (!this.selectedsServices.length) {
        // Nenhum servico selecionado
        return
      }
      const data = {
        ids_servicos: JSON.stringify(
          this.selectedsServices.map((s) => {
            return s.id_servico || s
          })
        ),
      }
      this.loadingNovo = true
      const r = await con.post(servicos.generate_link_adesao, data)
      if (r.status === 200) {
        this.linkAdesao = r.value.url_link
      }
      this.loadingNovo = false
    },
    async selectedService() {
      this.selectedsServices.push(this.service)
      // await this.generateLinkAdesao()
      this.step = Number(this.step) + 1
    },
    async getServices() {
      if (this.service || this.loadingServices) {
        return
      }
      this.loadingServices = true
      let aux = []
      const r = await con.get(sendLink.listar_servicos)
      if (r && r.status === 200) {
        aux = r.value.filter((s) => {
          // .value
          return s.status === 'ATIVO'
        })
      }
      let auxD = []
      // const rD = await con.get(servicos.profissional.disponiveis)
      // if (rD.status === 200) {
      //   auxD = rD.value.filter(s => {
      //     return s.status === 'ATIVO'
      //   })
      // }
      this.servicos = [...new Set([...aux, ...auxD])]
      this.loadingServices = false
    },
    async selectService(input) {
      this.selectedsServices.push(input)
      await this.generateLinkAdesao()
      this.step = Number(this.step) + 1
    },
    async selectedClients(input) {
      this.selectedsClients.push(input)
      if (this.service) {
        await this.generateLinkAdesao()
      }
      this.step = Number(this.step) + 1
    },
    async sendComunicate({ close, prospects, clients }) {
      const data = {
        assunto_email: this.assunto_email,
        _from: this.emailFrom,
        texto_email: this.texto_email,
        enviar_imagem: this.enviar_imagem,
        enviar_copia: this.enviar_copia,
        enviar_anexo: this.enviar_anexo,
        email_cco: '',
        email_cc: '',
        receber_copia: this.receber_copia,
        enviar_assinatura_email: this.enviar_assinatura_email,
      }

      let resProspects = { status: 200 }
      if (prospects.length) {
        resProspects = await apiClientsComunication.sendComunicate({
          id_cliente: JSON.stringify(prospects),
          hasIdCadastroCliente: true,
          ...data,
        })
      }

      let resClients = { status: 200 }
      if (clients.length) {
        resClients = await apiClientsComunication.sendComunicate({
          id_cliente: JSON.stringify(clients),
          hasIdCadastroCliente: false,
          ...data,
        })
      }

      return {
        resClients,
        resProspects,
      }
    },
    async sendEmail(close) {
      if (this.loadingNovo) {
        return
      }
      this.loadingNovo = true

      let prospects = this.selectedsClients
        .filter((c) => {
          return !!c.id_cadastro_cliente
        })
        .map((c) => {
          return c.id_cadastro_cliente
        })
      prospects = [...new Set(prospects)]

      let clients = this.selectedsClients
        .filter((c) => {
          return !!c.id_cliente
        })
        .map((c) => {
          return c.id_cliente
        })
      clients = [...new Set(clients)]

      let r, rP
      if (!this.selectedsServices.length) {
        const { resClients, resProspects } = await this.sendComunicate({
          close,
          prospects,
          clients,
        })
        r = resClients
        rP = resProspects
      } else {
        const servicos = this.selectedsServices.map((s) => {
          return s.id_servico
        })
        const data = {
          // id_cliente: JSON.stringify([...new Set(clientes)]),
          ids_servicos: JSON.stringify([...new Set(servicos)]),
          assunto_email: this.assunto_email,
          from: this.emailFrom,
          texto_email: this.texto_email,
          enviar_imagem: this.enviar_imagem,
          enviar_copia: this.enviar_copia,
          enviar_anexo: this.enviar_anexo,
          email_cco: '',
          email_cc: '',
          receber_copia: this.receber_copia,
          enviar_assinatura_email: this.enviar_assinatura_email,
        }

        // Enviar para os clientes
        // Criando formato padrao para passar na verificacao caso nao ocorra a requisicao
        r = { status: 200 }
        if (clients.length) {
          r = await con.post(cadastroClientes.send_link_client, {
            ...data,
            id_cliente: JSON.stringify(clients),
          })
        }

        // Enviar para os prospects
        // Criando formato padrao para passar na verificacao caso nao ocorra a requisicao
        rP = { status: 200 }
        if (prospects.length) {
          rP = await con.post(cadastroClientes.send_link, {
            ...data,
            id_cliente: JSON.stringify(prospects),
          })
        }
      }

      if (r.status === 200 || rP.status === 200) {
        GlobalBus.$emit(RELOAD.SEND_LINK)
        this.executeClientTask(r, rP, clients, prospects)
      }

      this.$showSnack(this.montarFeedbackEnvio(r, rP))
      this.loadingNovo = false
      if (r.status === 200 && rP.status === 200) {
        this.nextStepNovo(close)
      }
    },
    /**
     * Monta o snack a partir das duas respostas do envio (`r` = clientes,
     * `rP` = prospects), que podem ter status diferentes.
     *
     * Por que existe [review-lote]: a rota de lote não aborta mais no primeiro
     * cliente sem e-mail — ela devolve `status: 200` com
     * `value = { enviados, sem_email, falhas }` e uma `message` acionável
     * dizendo quantos e quais ficaram de fora. O código antigo só exibia
     * `message` quando `status !== 200`, então o envio parcial virava
     * "Links enviados com sucesso" e o assessor não sabia que 3 de 10 clientes
     * não receberam. A `message` do backend é a fonte do texto: ele sabe os ids.
     */
    montarFeedbackEnvio(r, rP) {
      const respostas = [r, rP].filter((res) => {
        return !!res
      })

      let houveErro = false
      let houveParcial = false
      const mensagens = []

      respostas.forEach((res) => {
        const erro = res.status !== 200
        const parcial = envioParcial(res)
        if (erro) {
          houveErro = true
        }
        if (parcial) {
          houveParcial = true
        }
        if ((erro || parcial) && res.message) {
          mensagens.push(res.message)
        }
      })

      if (!houveErro && !houveParcial) {
        return {
          text: MENSAGEM_LOTE_SUCESSO,
          color: 'success',
          button: true,
        }
      }

      const padrao = houveErro
        ? MENSAGEM_ERRO_SEM_DETALHE
        : MENSAGEM_PARCIAL_SEM_DETALHE

      return {
        text: mensagens.length ? mensagens.join('\n') : padrao,
        color: houveErro ? 'error' : 'warning',
        button: true,
      }
    },
    executeClientTask(r, rP) {
      if (!this.args) {
        return
      }
      const { task } = this.args
      const ids = this.selectedsClients.map((c) => {
        return c.id
      })

      const data = {
        id_tarefa: task.id_tarefa,
        ids: JSON.stringify(ids),
      }
      con.post(tarefasDia.confirm, data)
    },
    clearData() {
      this.step = 1
      this.email = ''
      this.selectedsServices = []
      this.selectedsClients = []
      this.assunto_email = ''
      this.texto_email = ''
      this.enviar_assinatura_email = false
      this.enviar_imagem = false
      this.enviar_anexo = false
      this.receber_copia = false
      this.service = ''
      this.showClients = true
      this.loadingClients = false
      this.loadingServices = false
      this.loadingNovo = false
      this.servicos = []
      this.clients = []
      this.searchClient = ''
      this.emailFrom = ''
      this.shareLink = 'by_link'
      this.linkAdesao = ''
      this.enviar_copia = false
      this.email_cco = ''
      this.email_cc = ''
      this.close = false
      this.id_prospect = ''
      this.getData()
    },
    copyClipboard(input) {
      copyToClipboard(this.$refs[input].$refs.input, this)
      this.atualizarStatusAoCopiar()
    },
    toServices() {
      if (this.$route.name.includes('servicos')) {
        this.busModal.$emit('dialog', false)
      } else {
        this.$router.push({ name: 'servicos' })
      }
    },
    atualizarStatusAoCopiar() {
      const data = {
        ids_clientes: this.selectedsClients.map((c) => {
          return c.id_cadastro_cliente || c.id_cliente
        }),
      }
      con.post(sendLink.on_copy, data)
      this.executeClientTask()
    },
    selectAllClients(check) {
      this.selectedsClients = check ? this.clients : []
    },
    calcStep(num) {
      if (this.service) {
        if (num !== 1) {
          num -= 1
        }
      }
      if (!this.showClients) {
        if (num !== 1) {
          num -= 1
        }
      }
      return num
    },
  },
}
</script>

<template>
  <BaseModal max-width="90%" height="90vh" :bus="busModal" persistent>
    <SectionTitle title="Enviar link de adesão" :subtitle="textSubtitle" />
    <div>
      <v-stepper
        :key="key"
        v-model="step"
        class="elevation-0"
        style="width: 100%"
      >
        <v-stepper-header class="elevation-0">
          <v-stepper-step
            v-if="showClients"
            :editable="step > calcStep(1)"
            :step="calcStep(1)"
            :complete="selectedsClients.length > 0"
          >
            Escolha o(os) clientes
          </v-stepper-step>
          <v-divider v-if="showClients" />
          <v-stepper-step
            v-if="!service"
            :editable="step > calcStep(2)"
            :step="calcStep(2)"
            :complete="selectedsServices.length > 0"
          >
            Escolha o(os) serviço
          </v-stepper-step>
          <v-divider v-if="!service" />
          <v-stepper-step :editable="step > calcStep(3)" :step="calcStep(3)">
            Envie o link
          </v-stepper-step>
          <v-divider />
          <v-stepper-step :step="calcStep(4)">
            Acompanhe o status
          </v-stepper-step>
        </v-stepper-header>

        <v-stepper-items class="elevation-0" style="min-height: 200px">
          <v-stepper-content v-if="showClients" :step="calcStep(1)">
            <div class="input-group align-items-center pb-2">
              <v-text-field
                v-model="searchClient"
                label=""
                placeholder="Procurar cliente"
                single-line
                hide-details
                class="input short-search"
                :class="$style.alignCenter"
                append-icon=" "
                style="max-height: 42px; min-height: 42px !important; margin-top: 6px !important"
                full-width
              ></v-text-field>
              <button
                class="btn btn-icon btn-icon-secondary align-self-center"
                style="margin-top: 4px"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="19.276"
                  height="19.966"
                  viewBox="0 0 19.276 19.966"
                >
                  <path
                    class="fill"
                    d="M19.967 18.186l-4.752-4.942a8.058 8.058 0 1 0-6.17 2.879 7.975 7.975 0 0 0 4.618-1.459l4.788 4.98a1.051 1.051 0 1 0 1.516-1.458zM9.045 2.1a5.958 5.958 0 1 1-5.958 5.961A5.965 5.965 0 0 1 9.045 2.1z"
                    transform="translate(-.984)"
                  />
                </svg>
              </button>
            </div>
            <v-data-table
              v-if="showClients"
              v-model="selectedsClients"
              :headers="headersClients"
              :items="clients"
              show-select
              height="235"
              item-key="login"
              :search="searchClient"
              :loading="loadingClients"
              fixed-header
            >
              <template v-slot:header.data-table-select>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <div v-on="on">
                      <v-checkbox
                        :key="
                          selectedsClients.length > 0 &&
                            selectedsClients.length !== clients.length
                        "
                        color="gray"
                        :indeterminate="
                          selectedsClients.length > 0 &&
                            selectedsClients.length !== clients.length
                        "
                        :input-value="
                          selectedsClients.length === clients.length &&
                            !loadingClients
                        "
                        @change="selectAllClients"
                      />
                    </div>
                  </template>
                  <span
                    :key="
                      selectedsClients.length > 0 &&
                        selectedsClients.length !== clients.length
                    "
                    >{{
                      selectedsClients.length !== clients.length
                        ? 'Selecionar todos'
                        : 'Deselecionar todos'
                    }}</span
                  >
                </v-tooltip>
              </template>
              <template v-slot:item.nome_cliente="{ item }">
                <td>
                  <v-row style="align-items: center;">
                    <v-icon
                      v-if="!item.id_cadastro_cliente"
                      small
                      right
                      color="primary"
                    >
                      mdi-account
                    </v-icon>
                    <v-icon v-else small right>
                      mdi-account-switch
                    </v-icon>
                    <p style="margin-bottom: 0px; margin-left: 5px">
                      {{ item.nome_cliente }}
                    </p>
                  </v-row>
                </td>
              </template>
              <template v-slot:item.email="{ item }">
                {{ (item.email || '').toLowerCase() }}
              </template>
              <template v-slot:item.action="{ item }">
                <v-btn text icon small @click="selectedClients(item)">
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
              </template>
              <template v-slot:no-data>
                <p class="pt-3">Nenhum cliente encontrado</p>
                <BaseButton primary small @click="openNewClient">
                  <strong>+</strong> Cliente
                </BaseButton>
              </template>
            </v-data-table>
          </v-stepper-content>

          <v-stepper-content v-if="!service" :step="calcStep(2)">
            <div>
              <p class="text-secondary" style="text-align: center">
                Serviços enviados pelo link de adesão não terão comissionamento,
                caso queira receber seu comissionamento envie o link do serviço
                pela tela dos
                <a @click="toServices">Meus Serviços.</a>
              </p>
            </div>
            <v-data-table
              v-if="!service"
              v-model="selectedsServices"
              :headers="headersServices"
              :items="servicos"
              item-key="id_servico"
              hide-default-footer
              show-select
              height="300"
              :loading="loadingServices"
              fixed-header
              disable-pagination
            >
              <template v-slot:item.action="{ item }">
                <v-btn text icon small @click="selectService(item)">
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
              </template>
              <template v-slot:no-data>
                <p class="pt-3">Nenhum serviço encontrado</p>
                <BaseButton primary small @click="openNewService">
                  <strong>+</strong> Serviço
                </BaseButton>
              </template>
            </v-data-table>
          </v-stepper-content>

          <v-stepper-content :step="calcStep(3)" class="pt-0">
            <div style="min-height: 50vh">
              <v-row>
                <v-col>
                  <v-tabs
                    v-if="calcStep(3) === step"
                    v-model="shareLink"
                    slider-size="2"
                    slider-color="primary"
                  >
                    <v-tab
                      v-if="selectedsServices.length"
                      href="#by_link"
                      style="font-size: 16px"
                    >
                      Copiar link
                    </v-tab>
                    <v-tab href="#by_email">Enviar e-mail</v-tab>

                    <v-tab-item
                      v-if="selectedsServices.length"
                      class="pt-4"
                      value="by_link"
                    >
                      <p>
                        Copie e compartilhe o link de adesão do seu serviço com
                        o seu cliente.
                      </p>
                      <v-text-field
                        ref="linkAdesao"
                        v-model="linkAdesao"
                        readonly
                        label="Link de adesão"
                      >
                        <template v-slot:append>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn
                                icon
                                v-on="on"
                                @click="copyClipboard('linkAdesao')"
                              >
                                <v-icon>mdi-content-copy</v-icon>
                              </v-btn>
                            </template>
                            <span>Copiar link</span>
                          </v-tooltip>
                        </template>
                      </v-text-field>
                    </v-tab-item>

                    <v-tab-item
                      class="pt-1 px-2"
                      style="max-width: 100%; overflow-y: auto; overflow-x: hidden;"
                      value="by_email"
                    >
                      <v-row>
                        <v-col>
                          <!-- cc -->
                          <!-- cco -->
                          <SelectEmail v-model="emailFrom" />
                          <v-text-field
                            v-model="assunto_email"
                            hide-details
                            label="Assunto"
                          />
                          <v-textarea
                            v-model="texto_email"
                            hide-details
                            rows="3"
                            label="Corpo"
                          />
                        </v-col>
                        <v-col style="margin-left: 10px">
                          <!-- <v-checkbox
                            v-model="enviar_assinatura_email"
                            hide-details
                            label="Assinatura de e-mail"
                          /> -->
                          <v-checkbox
                            v-model="enviar_imagem"
                            hide-details
                            label="Incluir imagem do serviço"
                          />
                          <v-checkbox
                            v-model="enviar_anexo"
                            hide-details
                            label="Incluir anexo do serviço"
                          />
                          <!-- <v-checkbox
                            v-model="receber_copia"
                            hide-details
                            label="Receber cópia"
                          /> -->
                        </v-col>
                      </v-row>
                    </v-tab-item>
                  </v-tabs>
                </v-col>
                <v-col v-if="shareLink === 'by_link'">
                  <h3>
                    Compartilhe o link de adesão com o seu cliente
                  </h3>
                  <div class="v-application mt-5">
                    <v-timeline dense>
                      <v-timeline-item>
                        <template v-slot:icon>
                          <span class="text-light">1</span>
                        </template>
                        Compartilhe o link com seu cliente
                      </v-timeline-item>
                      <v-timeline-item>
                        <template v-slot:icon>
                          <span class="text-light">2</span>
                        </template>
                        Seu cliente faz a adesão
                      </v-timeline-item>
                      <v-timeline-item>
                        <template v-slot:icon>
                          <span class="text-light">3</span>
                        </template>
                        Você recebe o pagamento e controla a posição dele
                      </v-timeline-item>
                    </v-timeline>
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-stepper-content>

          <v-stepper-content :step="calcStep(4)">
            <p>
              Através da tela de
              <a @click="toServices">Meus Serviços</a>
              você consegue controlar as adesões de seus clientes.
            </p>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </div>
    <template v-slot:actions="{ close }">
      <v-row :class="$style.row_cadastrar_cliente">
        <div v-if="step === calcStep(1)" class="d-flex">
          <BaseButton underlined @click="close">
            Cancelar
          </BaseButton>
          <BaseButton
            v-if="step === calcStep(1)"
            primary
            :class="$style.buttons_centralize"
            :loading="loadingNovo"
            @click="nextStepNovo(close)"
          >
            Continuar
          </BaseButton>
        </div>
        <div v-else class="d-flex">
          <BaseButton v-if="calcStep(4)" underlined @click="close">
            Sair
          </BaseButton>
          <BaseButton v-else underlined @click="step = Number(step) - 1">
            Voltar
          </BaseButton>
          <BaseButton
            v-if="step < calcStep(3)"
            primary
            :loading="loadingNovo"
            @click="nextStepNovo(close)"
          >
            Continuar
          </BaseButton>
          <BaseButton
            v-if="step === calcStep(3) && shareLink === 'by_link'"
            primary
            :loading="loadingNovo"
            @click="nextStepNovo(close)"
          >
            Continuar
          </BaseButton>
          <BaseButton
            v-if="step === calcStep(3) && shareLink === 'by_email'"
            primary
            :loading="loadingNovo"
            @click="sendEmail(close)"
          >
            Enviar
          </BaseButton>
        </div>
      </v-row>
    </template>
  </BaseModal>
</template>

<style lang="sass" module>

.buttons_centralize
  padding-left: 10px
  padding-right: 10px

.row_cadastrar_cliente
  align-items: center
  justify-content: center

.v-text-field v-label
  margin-top: 6px !important
.v-text-field__slot input
  margin-top: 6px !important

.alignCenter
  input
    margin-top: 0px !important
</style>
